import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * ONLY AVAILABLE IN NODE.JS RUNTIME.
 *
 * This is a helper class to construct a string representing the services accessible by an AccountSAS. Setting a value
 * to true means that any SAS which uses these permissions will grant access to that service. Once all the
 * values are set, this should be serialized with toString and set as the services field on an
 * {@link AccountSASSignatureValues} object. It is possible to construct the services string without this class, but
 * the order of the services is particular and this class guarantees correctness.
 */
export var AccountSASServices = /*#__PURE__*/function () {
  function AccountSASServices() {
    _classCallCheck(this, AccountSASServices);

    /**
     * Permission to access blob resources granted.
     */
    this.blob = false;
    /**
     * Permission to access file resources granted.
     */

    this.file = false;
    /**
     * Permission to access queue resources granted.
     */

    this.queue = false;
    /**
     * Permission to access table resources granted.
     */

    this.table = false;
  }
  /**
   * Creates an {@link AccountSASServices} from the specified services string. This method will throw an
   * Error if it encounters a character that does not correspond to a valid service.
   *
   * @param services -
   */


  _createClass(AccountSASServices, [{
    key: "toString",
    value:
    /**
     * Converts the given services to a string.
     *
     */
    function toString() {
      var services = [];

      if (this.blob) {
        services.push("b");
      }

      if (this.table) {
        services.push("t");
      }

      if (this.queue) {
        services.push("q");
      }

      if (this.file) {
        services.push("f");
      }

      return services.join("");
    }
  }], [{
    key: "parse",
    value: function parse(services) {
      var accountSASServices = new AccountSASServices();

      var _iterator = _createForOfIteratorHelper(services),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;

          switch (c) {
            case "b":
              accountSASServices.blob = true;
              break;

            case "f":
              accountSASServices.file = true;
              break;

            case "q":
              accountSASServices.queue = true;
              break;

            case "t":
              accountSASServices.table = true;
              break;

            default:
              throw new RangeError("Invalid service character: ".concat(c));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return accountSASServices;
    }
  }]);

  return AccountSASServices;
}();